<div class="modal-header ">
  <h4>{{flag?'Update Member':'Add Member'|translate}}</h4>
  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="activeModal.close()">
  </button>
</div>
<div class="modal-body pt-0">
  <div class=" col-md-12">
    <section>
      <form [formGroup]="memberForm">
        <div class="row">
          <div class="col-md-4 pr-0 order-md-1" style="padding-top: 36px; padding-right: 0px; padding-left: 32px;">
            <div class="col-md-9">
              <aside class="user-info-wrapper">
                <div class="user-info">
                  <div class="user-avatar">
                    <edit-avatar (change)="selectFile($event)">
                    </edit-avatar>
                    <img [src]="url() ? url() : 'assets/img/download.png'" style="width: 100%;" alt="User">
                  </div>
                </div>
              </aside>
            </div>
          </div>
          <div class="col-md-8 pl-0 order-md-2" style="margin-left: -7px;">
            <div class="row ml-2">
              <div class="col-md-6" #parent4>
                <div class="mb-3" [ngClass]="{'has-danger':(submitted && memberForm.get('name').invalid)}">
                  <label class="text-muted  required" for="name">{{'Name'|translate}}</label>
                 
                  <indic-input [parentEl]="parent4" formControlName="name" tabindex="-1" required>
                    <show-errors *ngIf="submitted" [control]="memberForm.get('name')" [field]="'Name'">
                    </show-errors>
                  </indic-input>
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3" [ngClass]="{'has-danger':(submitted && memberForm.get('type').invalid)}">
                  <label class="text-muted  required" for="type">{{'Member'|translate}} {{'Type'|translate}}</label>
                  <app-auto-suggest tabindex="2" formControlName="type" placeholder="Choose {{'Member'|translate}}"
                    [inputCssClass]="'form-control form-control-sm'" [options]="allMemberType" required>
                    <ng-template addMore>
                      <div class="row ">
                        <div class="col-md-9 auto_suggest_footer" (click)="newMemberType(addMemberType)" tabindex="0">
                          <a>
                            <i class="fa fa-plus-circle" style="font-size:20px; " aria-hidden="true"></i>&nbsp; Add
                            {{'Member Type'|translate}}
                          </a>
                        </div>
                        <div class="col-md-3">
                          <i data-bs-toggle="tooltip" title="all member type" class="material-icons settings"
                            style="font-size:20px;" (click)="allMemberTypeModal(allMemberTypeView)"></i>
                        </div>
                      </div>
                    </ng-template>
                  </app-auto-suggest>
                  <show-errors *ngIf="submitted" [control]="memberForm.get('type')" [field]="'Type'"></show-errors>
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3" [ngClass]="{'has-danger':(submitted && memberForm.get('phone').invalid)}">
                  <label class="text-muted  required" for="phone">{{'Phone'|translate}}</label>
                  <input type="phoneNumber" id="name" class="form-control form-control-sm" formControlName="phone"
                    required>
                  <show-errors *ngIf="submitted" [control]="memberForm.get('phone')" [field]="'Phone'">
                  </show-errors>
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3" [ngClass]="{'has-danger':(submitted && memberForm.get('email').invalid)}">
                  <label class="text-muted  required" for="email">{{'Email'|translate}}</label>
                  <input type="email" id="name" class="form-control form-control-sm" formControlName="email"
                    emailValidator>
                  <show-errors *ngIf="submitted" [control]="memberForm.get('email')" [field]="'email'">
                  </show-errors>
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3" [ngClass]="{ 'has-danger' : (submit && memberForm.get('dob').invalid) }">
                  <label class="text-muted" for="large-rounded-input">{{'Date Of Birth'|translate}}</label>
                  <datetime name="dateFrom" [datepicker]="datepickerOpts" formControlName="dob" [timepicker]="false">
                  </datetime>
                </div>
              </div>              
              <div class="col-md-6">
                <div class="mb-3" [ngClass]="{'has-danger':(submitted && memberForm.get('memberId').invalid)}">
                  <label class="text-muted  required" for="memberId">{{'Member'|translate}} Id</label>
                  <input type="text" id="memberId" class="form-control form-control-sm" formControlName="memberId" autofocus
                    required>
                  <show-errors *ngIf="submitted" [control]="memberForm.get('memberId')" [field]="'Member Id'">
                  </show-errors>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="mb-3" [ngClass]="{ 'has-danger' : (submit && memberForm.get('star').invalid) }">
              <label class="text-muted" style="margin-bottom: 4px;" for="large-rounded-input">{{'Star'|translate}}
              </label>
              <div class="mb-3">
                <app-auto-suggest formControlName="star" placeholder="{{'Choose Star'|translate}}"
                  [inputCssClass]="'form-control form-control-sm'" [options]="nakshatraOptions">
                </app-auto-suggest>
                <!-- <show-errors *ngIf="submit" [control]="newDevoteeForm.get('star')" [field]="'Devotee Star' |translate"></show-errors> -->
              </div>
            </div>
          </div>
          <div class="col-md-4" #parent2>
            <div class="mb-3">
              <label class="text-muted  required" for="name">{{'Nominee '|translate}}</label>
              <app-auto-complete *ngIf="!flag" formControlName="nomineeId" [options]="vazhipadOptions"
                [settings]="vazipadNameSettings">
              </app-auto-complete>
              <select *ngIf="!!flag" class="form-control form-control-sm" formControlName="nomineeId">
                <option *ngFor="let d of vazhipadOptions" value="{{d.id}}">{{d.name}}</option>
              </select>
            </div>
          </div>
          <div class="col-md-4" #parent4>
            <div class="mb-3" [ngClass]="{'has-danger':(submitted && memberForm.get('name').invalid)}">
              <label class="text-muted  required" for="name">{{'Nominee Relation'|translate}}</label>
              <select class="form-control form-control-sm" formControlName="relation">
                <option value="FATHER">FATHER </option>
                <option value="MOTHER">MOTHER </option>
                <option value="SON">SON </option>
                <option value="DAUGHTER">DAUGHTER </option>
                <option value="NEPHEW">NEPHEW </option>
                <option value="WIFE">WIFE </option>
                <option value="HUSBAND">HUSBAND </option>
                <option value="BRIDE">BRIDE </option>
                <option value="GROOM">GROOM </option>
                <option value="BRIDE_FATHER">BRIDE_FATHER </option>
                <option value="BRIDE_MOTHER">BRIDE_MOTHER </option>
                <option value="GROOM_FATHER">GROOM_FATHER </option>
                <option value="GROOM_MOTHER">GROOM_MOTHER </option>
                <option value="OTHER">OTHER </option>
              </select>
            </div>
          </div>
          <div class="col-md-4" *ngIf="!!flag" #parent4>
            <div class="mb-3">
              <label class="text-muted required" for="name">STATUS</label>
              <select class="form-control form-control-sm" formControlName="status" >
                <option value="ACTIVE">ACTIVE </option>
                <option value="INACTIVE">INACTIVE </option>
                <option value="EXPIRED">EXPIRED</option>
              </select>
            </div>
          </div>
          <div class="col-md-8" #parent5>
            <div class="mb-3" [ngClass]="{'has-danger':(submitted && memberForm.get('address').invalid)}">
              <label class="text-muted  required">{{'Address'|translate}}</label>
              <indic-input [parentEl]="parent5" [inputOptions]="{keyboardEnable:true,inputarea: 'textarea'}"
                tabindex="-1" formControlName="address" required>
                <show-errors *ngIf="submitted" [control]="memberForm.get('address')" [field]="'Address'">
                </show-errors>
              </indic-input>
            </div>
          </div>
        </div>
      </form>
      <!-- <div class="row">
        <div class="col-md-10"></div>
        
      </div> -->
    </section>
  </div>
</div>
<div class="modal-footer">
  <div class="col-md-12">
    <div class="mb-3  pull-right">
      <button class="btn btn-outline-secondary btn-sm" role="button" (click)="activeModal.close()">
        &nbsp;{{'Cancel'|translate}}
      </button>
      <!-- <button class="btn btn-outline-primary btn-sm" role="button" (click)="reset()">
        &nbsp;{{'Reset'|translate}}
      </button> -->
      <button class="btn  btn-success btn-sm" role="button" (click)="submit()">
        &nbsp;{{flag?'Update':'Save'}}
      </button>
    </div>
  </div>
</div>

<ng-template #addMemberType let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4> Add Member Type </h4>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="close(modalRef)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form autocomplete="off" class="row">
      <div class="col-sm-12">
        <div class="mb-3 " [ngClass]="{'has-danger':(submitting && !memberType)}">
          <label class="text-muted" for="large-rounded-input">Member Type</label>
          <input class="form-control form-control-sm" type="text" [ngModelOptions]="{standalone: true}"
            [(ngModel)]="memberType">
          <small class="text-danger" *ngIf="submitting && !memberType">
            Member Type {{'is required'|translate}}
          </small>
        </div>
      </div>
      <hr class="padding-bottom-1x">
    </form>
  </div>
  <div class="modal-footer">
    <button class="btn btn-secondary btn-sm" type="button" (click)="close(modalRef)">cancel</button>
    <button class="btn btn-success btn-sm" type="button" (click)="submitMemberType()">Submit</button>
  </div>
</ng-template>

<ng-template #allMemberTypeView let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4>All Member Type </h4>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <table class="table table-striped">
      <thead>
        <tr>
          <th>{{'Member'|translate}} {{'Type'|translate}}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let p of allMemberType,let i=index;">
          <td #parent3>
            <ng-container *ngIf="p.selected;else other">{{p.name ? p.name: '-'}}</ng-container>
          </td>
          <ng-template #other>
            <indic-input [parentEl]="parent3" [(ngModel)]="p.name"></indic-input>
          </ng-template>
          <td>
            <i data-bs-toggle="tooltip" *ngIf="p.selected" title="edit member type" class="fa fa-edit"
              (click)="editMemberType(p)"></i>
            <i data-bs-toggle="tooltip" *ngIf="!p.selected" title="save member type" class="fa fa-save"
              (click)="save(p)"></i>
            <i data-bs-toggle="tooltip" *ngIf="!p.selected" title="cancel edit member type" class="fa fa-close"
              (click)="undo(p)"></i>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-template>